import { render, staticRenderFns } from "./StudentLogin.vue?vue&type=template&id=7bbb8a9d&"
import script from "./StudentLogin.vue?vue&type=script&lang=js&"
export * from "./StudentLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports